import keyMirror from 'react-utils/keyMirror';
import * as HubLVideoParams from 'FileManagerCore/constants/HubLVideoParams';
export { PANEL_WIDTH, PANEL_WIDTH_EXPANDED } from 'file-manager-components/constants';
export const PAGE_SIZE = 90;
export const SEARCH_DEBOUNCE_MS = 500;
export const Panels = {
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  STOCK_IMAGES: 'STOCK_IMAGES',
  FOLDER: 'FOLDER',
  FROM_URL: 'FROM_URL',
  FILE_DETAIL: 'FILE_DETAIL',
  BULK_IMPORT_FROM_URL: 'BULK_IMPORT_FROM_URL',
  IMAGE_GENERATION: 'IMAGE_GENERATION',
  LANDING: 'LANDING'
};
export const SortByFilters = {
  UPDATED: '-updated',
  NAME: 'name',
  SIZE: 'size'
};
export const DEFAULT_SORT_BY_FILTER = SortByFilters.UPDATED;
export const CellTypes = keyMirror({
  FILE: null,
  FOLDER: null,
  THUMBNAIL: null,
  EMPTY: null
});
export const IMAGE_COLUMN_COUNT = 3;
export const DEFAULT_ROWS_TO_FETCH = 15;
export const FETCH_FILES_LIMIT = IMAGE_COLUMN_COUNT * DEFAULT_ROWS_TO_FETCH;
export const FILE_FOLDER_THUMB_SIZE = 34;
export const FILE_FOLDER_THUMB_SIZE_EXPANDED = 50; // half of THUMB width (100px) for ideal retina display
export const IMAGE_THUMBNAIL_WIDTH = 120;
export const IMAGE_THUMBNAIL_HEIGHT = 90;
export const IMAGE_THUMBNAIL_WIDTH_PICKER_LIGHT = 80;
export const IMAGE_THUMBNAIL_HEIGHT_PICKER_LIGHT = 64;
export const PICKER_FOLDER_CLASSNAME = 'folder-row';
export const PANEL_WIDTH_COMPACT_THRESHOLD = 530;
export const COLUMN_COUNT = 4;
export const COMPACT_COLUMN_COUNT = 3;
export const TrackingPanelLabels = {
  [Panels.BROWSE]: 'browse',
  [Panels.SEARCH]: 'search',
  [Panels.STOCK_IMAGES]: 'stock-images',
  [Panels.FOLDER]: 'browse-folders',
  [Panels.FROM_URL]: 'from-url',
  [Panels.FILE_DETAIL]: 'file-details]',
  [Panels.BULK_IMPORT_FROM_URL]: 'bulk-import-from-url',
  [Panels.IMAGE_GENERATION]: 'image-generation',
  [Panels.LANDING]: 'landing'
};
export const PickerTypes = keyMirror({
  PANEL: null,
  SIDE_MODAL: null
});
export const DrawerTypes = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  HUBL_VIDEO: 'HUBL_VIDEO',
  DOCUMENT: 'DOCUMENT',
  FILE: 'FILE',
  AUDIO: 'AUDIO'
};
export const UploadStatus = {
  FINISHED: 'FINISHED',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  NOT_STARTED: 'NOT_STARTED'
};
export const SupportedHubLVideoParams = HubLVideoParams.SupportedHubLVideoParams;
export const LANDING_PANEL_FOLDER_LIMIT = 4;
export const LANDING_PANEL_FILE_LIMIT_GRID = 12;
export const LANDING_PANEL_FILE_LIMIT_LIST = 6;
export const PICKER_HEIGHT_FOR_DEFAULT_LANDING_PANEL_LIMITS = 900;

// These are test ids used in consumers library for their ATs downstream.
// Allows consumers to more easily harden tests and find upstream problems
// faster.
export const EXTERNAL_TEST_IDS = {
  TITLE_CELL: 'tile-cell'
};